export default __webpack_public_path__ + "locales/sl/SharingPanel.json?hash=5c6ad951e91c4f29d0af2f488a6c681e";